import { useMutation } from '../';
import { updateNotificationRule } from '../mutations';

export function useUpdateNotificationRule() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(updateNotificationRule, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.updateNotificationRule.id);
      }
    });
  };

  return { data, isLoading, run };
}
